import { Record } from 'immutable';

const struct = {
  id:                     undefined,
  name:                   undefined,
  locale:                 undefined,
  logo:                   undefined,
  description:            undefined,
  jobBanner:              undefined,
  dataPolicyUrl:          undefined,
  parameters:             {},
  smsEnabled:             false,
  whatsappEnabled:        false,
  messengerEnabled:       false,
  messengerUrl:           undefined,
  listingsBanner:         undefined,
  landingPagePopUpScreen: undefined,
};

export default class Company extends Record(struct, 'Company') {
  privacyPolicyText() {
    if (!this.dataPolicyUrl) {
      return t('eos.landing_page.text.privacy_policy_talkpush');
    }

    return t('eos.landing_page.text.privacy_policy', { company: this.name, policy_url: this.dataPolicyUrl });
  }

  popUpPrivacyPolicyText() {
    return t('eos.landing_page.text.pop_up_privacy_policy', { company: this.name, policy_url: this.dataPolicyUrl });
  }

  /* Applicable only for LP's One question per page config */
  allowLandingPageResponseResubmit() {
    return [null, undefined, true].includes(this.parameters.landingPageResponseResubmit);
  }
}
